import { render, staticRenderFns } from "./is_2_com.vue?vue&type=template&id=c0ae7cca&scoped=true&"
import script from "./is_2_com.vue?vue&type=script&lang=js&"
export * from "./is_2_com.vue?vue&type=script&lang=js&"
import style0 from "./is_2_com.vue?vue&type=style&index=0&id=c0ae7cca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ae7cca",
  null
  
)

export default component.exports